module.exports = __webpack_public_path__ + "static/media/class_job_001.ad032b7a.svg";